const listingElements = document.getElementsByClassName('js-listing');
if(listingElements.length) {
    Array.prototype.forEach.call(listingElements, (el) => {
        const cards = el.querySelectorAll('.card');
        if( cards.length < 3) {
          el.classList.add('listing--two');
        }
    })

    document.addEventListener("DOMContentLoaded", function() {
      const featureListing = document.getElementsByClassName('js-listing');
      Array.prototype.forEach.call(featureListing, (el) => {
        var smallCards = el.getElementsByClassName('card__text');
        var largeCards =el.getElementsByClassName('card--large__text-inner');
        if(smallCards.length){
          cards = smallCards;
        } else if(largeCards.length) {
          cards = largeCards;
        }
      })
    })
}
